import { useContext } from 'react';

// Components
import { CompoundTableContext } from '@/components/base/Table/CompoundTable';
import DraggableColumnHeader from '@/components/base/Table/CompoundTable/TableHeader/DraggableColumnHeader';
import HeaderColumn from '@/components/base/Table/CompoundTable/TableHeader/HeaderColumn';
import TableHeaderDragAndDropContext from '@/components/base/Table/CompoundTable/TableHeader/TableHeaderDragAndDropContext';

function TableHeaderContent() {
    const { table } = useContext(CompoundTableContext);
    const stickyHeaderClassName = table.options.meta?.stickyHeader?.className ?? 'sticky top-0 z-2';

    return (
        <thead className={stickyHeaderClassName}>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                        const isReorderingActive =
                            'meta' in header.column.columnDef &&
                            'enableReordering' in header.column.columnDef.meta
                                ? header.column.columnDef.meta.enableReordering
                                : table.options.meta?.enableReorderingColumns;

                        if (isReorderingActive) {
                            return <DraggableColumnHeader key={header.id} header={header} />;
                        }

                        return <HeaderColumn key={header.id} header={header} />;
                    })}
                </tr>
            ))}
        </thead>
    );
}

function TableHeader() {
    const { table } = useContext(CompoundTableContext);

    if (table.options.meta?.enableReorderingColumns) {
        return (
            <TableHeaderDragAndDropContext>
                <TableHeaderContent />
            </TableHeaderDragAndDropContext>
        );
    }

    return <TableHeaderContent />;
}

export default TableHeader;
